import { useMemo } from "react";
import { encodeQr, qrPath } from "../lib/qr";

interface Props {
  /** What the code holds, e.g. the Google Maps route to a delivery address. */
  text: string;
  /** Read out for screen readers. */
  label: string;
}

/** A QR code as a sharp SVG (prototype qrSvg): black modules, no margin; it scales with its box. */
export function QrCode({ text, label }: Props) {
  const code = useMemo(() => encodeQr(text), [text]);
  return (
    <svg
      viewBox={`0 0 ${String(code.size)} ${String(code.size)}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <path d={qrPath(code)} fill="#000000" />
    </svg>
  );
}
